import axiosInstance from './api'


const transferToTeam = async (teamId, amount) => {
  const response = await axiosInstance.post(`/teams/${teamId}/coins/transfer/to-team`, {
    amount
  })
  return response.data
}


const transferToPersonal = async (teamId, amount) => {
  const response = await axiosInstance.post(`/teams/${teamId}/coins/transfer/to-personal`, {
    amount
  })
  return response.data
}


const getAvailableCoins = async (teamId) => {
  const response = await axiosInstance.get(`/teams/${teamId}/coins/transfer/available`)
  return response.data
}


const getUserTransferHistory = async (teamId, page = 1, limit = 20) => {
  const response = await axiosInstance.get(`/teams/${teamId}/coins/transfer/history`, {
    params: { page, limit }
  })
  return response.data
}


const getTeamTransferHistory = async (teamId, page = 1, limit = 20) => {
  const response = await axiosInstance.get(`/teams/${teamId}/coins/transfer/history/admin`, {
    params: { page, limit }
  })
  return response.data
}


const getTeamConsumptionHistory = async (teamId, page = 1, limit = 20) => {
  const response = await axiosInstance.get(`/teams/${teamId}/coins/consumption/history`, {
    params: { page, limit }
  })
  return response.data
}


const getTeamAccountActivity = async (teamId, page = 1, limit = 20, filter = 'all') => {
  const response = await axiosInstance.get(`/teams/${teamId}/coins/activity`, {
    params: { page, limit, filter }
  })
  return response.data
}


const getPersonalConsumptionHistory = async (page = 1, limit = 20) => {
  const response = await axiosInstance.get('/coins/consumption/personal', {
    params: { page, limit }
  })
  return response.data
}

const getPersonalTransferHistory = async (page = 1, limit = 20) => {
  const response = await axiosInstance.get('/coins/transfer/personal', {
    params: { page, limit }
  })
  return response.data
}


export const coinTransferApi = {
  transferToTeam,
  transferToPersonal,
  getAvailableCoins,
  getUserTransferHistory,
  getTeamTransferHistory,
  getTeamConsumptionHistory,
  getTeamAccountActivity,
  getPersonalConsumptionHistory,
  getPersonalTransferHistory
} 